/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React, {useContext} from 'react'
import intl from '../utils/intl/intl'

export interface LayoutManagementClient {
  getActiveLayout(
    layoutType: 'DetailedView',
    entityType: string,
    processId: number | null | undefined
  ): Promise<{id: string}>

  getLayoutVersionById(layoutId: string, version: string): Promise<{schema: any}>
}

interface ServicesContextValue {
  layoutManagementClient: LayoutManagementClient
}

export const ServicesContext = React.createContext<ServicesContextValue | null>(null)

export const ServicesContextProvider = ({
  value,
  children
}: {
  value: ServicesContextValue
  children: React.ReactNode
}) => <ServicesContext.Provider value={value}>{children}</ServicesContext.Provider>

export const useServices: () => ServicesContextValue = () => {
  const context = useContext(ServicesContext)

  if (context === null) {
    throw new Error(intl.formatMessage('Services context should be specified.'))
  }

  return context
}
